<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CookieBanner',
    data() {
        return {
            isVisble: false,
        }
    },
    mounted() {
        const cookieStore = localStorage.getItem('readCookie');
        if (!cookieStore) {
            this.isVisble = true;
        }
    },
    methods: {
        onClose() {
            this.isVisble = false;
            localStorage.setItem('readCookie', true);
        },
    },
};
</script>

<template>
    <transition name="slide-up">
        <div class="cookie-banner" v-if="isVisble">
            <div class="cookie-banner__inner">
                <p class="cookie-banner__message" v-html="$t('cookieBanner.message')"></p>
                <button class="cookie-banner__button" v-on:click="onClose"></button>
            </div>
        </div>
    </transition>
</template>

<style lang="scss">
.cookie-banner {
    position: fixed;
    bottom: 0; left: 0;
    width: 100%;
    z-index: 20;
    pointer-events: none;
}
.cookie-banner__inner {
    position: relative;
    width: 100%;
    max-width: 71.2rem;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 1.6rem 5.44rem 1.6rem 2rem;
    background: rgba($color-primary-alt, .9);
    pointer-events: all;
}
.cookie-banner__message {
    font-size: 1.6rem;
    color: $color-light;
    letter-spacing: 0.029rem;
    line-height: 1.3;
    margin: 0;

    a {
        color: $color-light;
        border-color: rgba($color-light, .5);
    }
}
.cookie-banner__button {
    position: absolute;
    top: 50%; right: 1.6rem;
    width: 2.1rem; height: 2.1rem;
    margin: -1.05rem 0;
    padding: 0;
    border: none;
    outline: none;
    background: center url('~@/assets/images/ico-close-overlay.svg') no-repeat transparent;
    background-size: 2.08rem;
    cursor: pointer;
    z-index: 1;
    transition: transform 100ms;
}
.cookie-banner__button:hover {
    @include breakpoint('md-up') {
        transform-origin: center;
        transform: scale(1.05);
    }
}

.slide-up-enter-active {
    transition: opacity 350ms 1500ms, transform 350ms 1500ms;
}
.slide-up-leave-active {
    transition: opacity 350ms, transform 350ms;
}
.slide-up-enter, .slide-up-leave-to  {
    opacity: 0;
    transform: translateY(30%);
}
</style>
